export default __webpack_public_path__ + "static/Discussion-questions-4eccc482024482fe7bedba78feb7ddf1.pdf";